export function setValueIndex(_ref) {
  var values = _ref.values,
    source = _ref.source,
    newValue = _ref.newValue,
    index = _ref.index;
  // Performance shortcut
  if (source[index] === newValue) {
    return source;
  }
  var output = values.slice();
  output[index] = newValue;
  return output;
}